export default __webpack_public_path__ + "static/media/6d.13550a5c.svg";